(function() { window.GUID_b2ea24a3_ca85_4312_99b6_e79b5234b2aa = { getGuid: function() { return "b2ea24a3-ca85-4312-99b6-e79b5234b2aa"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let NotificationType;
        (function (NotificationType) {
            NotificationType[NotificationType["Email"] = 0] = "Email";
            NotificationType[NotificationType["Push"] = 1] = "Push";
        })(NotificationType = Enumeration.NotificationType || (Enumeration.NotificationType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=NotificationType.pre.js.map
